import store from '../../../store/store';
import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { SHOP_ACTION_PROPOSALS_URL } from './action-api-urls';
import { ActionProposal, PaginatedResponse } from './action-types';

export interface GetActionProposalsParams {
  status?: string;
  platform?: string;
  category?: string;
  per_page?: number;
  page?: number;
}

export interface GetActionProposalsResponse {
  success: boolean;
  message: string | null;
  data: PaginatedResponse<ActionProposal> | null;
}

export default async function get_action_proposals_api_call(
  params?: GetActionProposalsParams
): Promise<PaginatedResponse<ActionProposal> | null> {
  try {
    const shopSlug = store.getState().user?.company?.shop_slug;
    const accessToken = store.getState().auth.authorization.accessToken;
    const sellerToken = accessToken?.sellerToken;

    let url = SHOP_ACTION_PROPOSALS_URL(shopSlug);

    if (params) {
      const queryParams = new URLSearchParams();
      if (params.status) queryParams.append('status', params.status);
      if (params.platform) queryParams.append('platform', params.platform);
      if (params.category) queryParams.append('category', params.category);
      if (params.per_page)
        queryParams.append('per_page', params.per_page.toString());
      if (params.page) queryParams.append('page', params.page.toString());

      const queryString = queryParams.toString();
      if (queryString) {
        url += `?${queryString}`;
      }
    }

    const requestInfo: RequestInfo = {
      url,
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: accessToken.type + ' ' + sellerToken,
      },
    };

    const actionType = 'GET_ACTION_PROPOSALS';
    const customMsg = 'Action proposals retrieved successfully.';

    const res: any = await asyncHandler(
      requestInfo,
      actionType,
      customMsg,
      false
    );

    const response: GetActionProposalsResponse = res?.data;

    if (res?.actionType === actionType && response?.success === true) {
      return response.data;
    } else {
      return null;
    }
  } catch (exception) {
    console.log('Error during get action proposals request');
    return null;
  }
}
